import { createFileRoute } from "@tanstack/react-router";
import { AdminFeedbackView } from "@/components/admin/AdminFeedbackView";

export const Route = createFileRoute("/_authenticated/admin/feedback")({
  head: () => ({ meta: [{ title: "Feedback — Admin" }] }),
  component: AdminFeedbackPage,
});

function AdminFeedbackPage() {
  return <AdminFeedbackView />;
}
